import { BaseField } from './BaseField';

const imgPriceIcon = "/assets/price-icon.svg";

export class PricePerMeterField extends BaseField {
  constructor() {
    super({
      key: 'price_per_meter',
      icon: imgPriceIcon,
      defaultLabel: 'Cena za m²'
    });
  }

  _label(property, params = {}) {
    if (params.label) return params.label;
    return property.propertyType === 'lokal uslugowy' ? 'Cena za m² (netto)' : this.defaultLabel;
  }

  _value(property) {
    return property.pricing.pricePerSquareMeter.format();
  }

  _result(property, params = {}) {
    const result = {
      label: this._label(property, params),
      value: this._value(property)
    };
    if (property.priceBadge?.isVisible) {
      const areaTotal = property.specifications.area.total;
      result.promo = {
        originalPrice: `${Math.round(property.priceBadge.originalPrice / areaTotal).toLocaleString('pl-PL')} zł/m²`
      };
    }
    return result;
  }

  renderForList(property, params = {}) {
    return this._result(property, params);
  }

  renderForCard(property, params = {}) {
    return this._result(property, params);
  }
}
